var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99984 11.825L5.8665 13.7166L6.6915 10.15L3.92484 7.74996L7.57484 7.44163L8.99984 4.07496L10.4248 7.44163L14.0748 7.74996L11.3082 10.15L12.1332 13.7166L8.99984 11.825ZM17.3332 6.69996L11.3415 6.19163L8.99984 0.666626L6.65817 6.19163L0.666504 6.69996L5.20817 10.6416L3.84984 16.5L8.99984 13.3916L14.1498 16.5L12.7832 10.6416L17.3332 6.69996Z",
    fill: "#909CA4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.27c7619d83b9f7d7baefca8ce8ccf10c.svg";
export { ForwardRef as ReactComponent };